import { connect } from 'react-redux';

import { IDispatchProps, IStoreProps, VillageObjects } from './VillageObjects';
import { getObjectsOnSale } from './helpers';
import { NavigationLinkTypes } from '../../constants/navigation';
import { NEW_OBJECTS_KEYS } from '../../interfaces/village';
import { IState } from '../../store';
import { setNavigationLink } from '../../store/navigation/actions';
import { TTypedThunkDispatch } from '../../types/store';

export function mapStateToProps(state: IState): IStoreProps {
  const { village } = state.villageData;
  const { cottage = null, townhouse = null, lowrisehouse = null, landplot = null } = village.newobjectCategorySet || {};
  const { offersSeo, counterSet = null, builderCounterSet = null, resaleCounterSet } = village || {};
  const objectsOnSale = counterSet && getObjectsOnSale(counterSet);
  let totalOnSaleCount = 0;

  if (objectsOnSale) {
    Object.values(objectsOnSale).forEach(value => {
      totalOnSaleCount += value;
    });
  }

  return {
    objects: {
      [NEW_OBJECTS_KEYS.COTTAGE]: cottage,
      [NEW_OBJECTS_KEYS.TOWNHOUSE]: townhouse,
      [NEW_OBJECTS_KEYS.LOWRISEHOUSE]: lowrisehouse,
      [NEW_OBJECTS_KEYS.LANDPLOT]: landplot,
    },
    objectsOnSale,
    builderObjectsOnSale: builderCounterSet && getObjectsOnSale(builderCounterSet),
    resaleObjectsOnSale: getObjectsOnSale(resaleCounterSet ?? {}),
    totalOnSaleCount,
    isCroppedCard: state.isCroppedCard,
    totalOnSaleUrl: offersSeo && offersSeo.url,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IDispatchProps {
  return {
    setNavigationLink: () => dispatch(setNavigationLink(NavigationLinkTypes.Objects)),
  };
}

export const VillageObjectsContainer = connect<IStoreProps, IDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(VillageObjects);
